import Service from "../../Service";
import Axios from '../../Config/API'
import { ITitulos, ITitulosResponse } from "../../../Interfaces/Cobranca/Titulos/TitulosInterface";

export function ListarTitulosCobrancaService<TResponseType extends ( ITitulosResponse | Blob )>(requestBody: ITitulos, exportExcel: boolean){
    return Service(
        Axios.post<TResponseType>(`/cobranca/listartituloscobranca/listartitulocobranca?exportExcel=${exportExcel}`,requestBody, {responseType: exportExcel? 'blob' : 'json'})
    )
}
